import { useEffect, useRef } from 'react';
import './App.css';

function App() {
  const ref = useRef(null)

  useEffect(() => {
    if (ref)
    setTimeout(() => {
      ref.current.style.display = 'none'
    }, 2000)
  }, [ref])

  return (
    <div className="App">
      <div className="black" ref={ref} />
      <iframe src="https://artogo.co/zh-TW/exhibition/MandarinAndTaiwanesePopularMusic/space/6bac2c878834?mode=embed" width="100%" height="100%" title='《鄉愁·流轉與禁聲噤語》' />
    </div>
  );
}

export default App;
